export { ModulePage as default } from './ModulePage';
